import { handleActions } from 'redux-actions'

const initialState = {
  showDialog: false,
  contact: {},
  continueBooking: false
}

const flaggedContactReducer = handleActions(
  {
    SHOW_FLAGGED_CONTACT_DIALOG: (state, action) => {
      return {
        showDialog: true,
        contact:
          action.payload && action.payload.contact
            ? action.payload.contact
            : {},
        continueBooking: false
      }
    },
    FLAGGED_CONTACT_DIALOG_CONTINUE_BOOKING: (state, action) => {
      return {
        showDialog: false,
        contact: {},
        continueBooking: true
      }
    },
    FLAGGED_CONTACT_DIALOG_RESET: () => initialState
  },
  initialState
)

export default flaggedContactReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/flaggedContactReducer.js